import { dom, mapActiveClass } from "../helpers/dom.js";


class FullThumbs {
  constructor(images, {onClick}) {
    this._urls = images.filter(image => image !== "") || [];
    this._onClick = onClick || (() => {});
  }
  init() {
    const dom = this._makeDom();
    if (this._images.length > 0) this.setActive(0);
    return dom;
  }
  setActive(targetIndex) {
    this._images.forEach((image, index) => {
      if (index === targetIndex) {
        image.classList.add("full__thumb--active");
      } else {
        image.classList.remove("full__thumb--active");
      }
    });
  }
  _makeDom() {
    this._images = this._urls.map((image, index) => {
      const thumb = dom("div.full__thumb", {}, [
        dom("img", { src: image }, null)
      ]);
      thumb.addEventListener("click", () => {
        this.setActive(index);
        this._onClick(index);
      });
      return thumb;
    });
    return dom("div.full__thumbs", {}, this._images);
  }
}

export default FullThumbs;



// WEBPACK FOOTER //
// ./src/js/components/fullThumbs.js